var exports = {
  "W$": "MenuItem.module__subtext___Tlk2Y2",
  "z": "MenuItem.module__sliderItem___Tlk2Y2",
  "r9": "MenuItem.module__disabled___Tlk2Y2",
  "Ry": "MenuItem.module__sliderHeader___Tlk2Y2",
  "KF": "MenuItem.module__sliderLabel___Tlk2Y2",
  "rv": "MenuItem.module__sliderValue___Tlk2Y2",
  "xJ": "MenuItem.module__sliderContainer___Tlk2Y2",
};

module.exports = exports;
